import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sp-delete-set-variant-new-dialog',
  templateUrl: './delete-set-variant-new-dialog.component.html',
  styleUrls: ['./delete-set-variant-new-dialog.component.scss']
})
export class DeleteSetVariantNewDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: any,
    private dialogRef: MatDialogRef<DeleteSetVariantNewDialogComponent>
  ) { }
  ngOnInit(): void { }

  deleteVariant(): void {
    this.dialogRef.close(true);
  }
  cancelDeleteVariant(): void {
    this.dialogRef.close(false);
  }

}
